export const MapSavedQuery = (beSavedQuery: any): any => {
    const savedQuery = {
        id: beSavedQuery.id,
        name: beSavedQuery.name,
        description: beSavedQuery.description,
        type: beSavedQuery.type,
        builder: beSavedQuery.builder,
        user: beSavedQuery.user_info,
        query: JSON.parse(beSavedQuery.query)
    }

    return savedQuery;
}